import { render } from "./pumps.vue?vue&type=template&id=96defac6&scoped=true"
const script = {}

import "./pumps.vue?vue&type=style&index=0&id=96defac6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-96defac6"

export default script